export default __webpack_public_path__ + "assets/lab2.a185aeb1.png";